<template>
  <div ref="ElementoGrafico">  
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico + 50"></canvas>
  </div>      
</template>

<script>
import { TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'
import { COLORI_DEFAULT_GRAFICI, TIPOLOGIA_GRAFICI_STORICI, SystemInformation, SPESSORE_LINEE_GRAFICI } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZMathFunct } from '@/utils/ZMathFunct'

export default 
{
  components: { },
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              ObjGrafico      : null,
              SpessoreGrafico : SPESSORE_LINEE_GRAFICI,
              Grafici         : {},
              LinguaUtente    : SystemInformation.UserInformation.Lingua
           }

  },
  props: [ "WidthGrafico", "HeightGrafico", "Dati", "Repaint", "RepaintDeep", "Tipo", "EventiSovrapposti", "MinData", "MinDataMs" ],

  methods:
  {
    GetMaxAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result < this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinAxisY()
    {
      let Result = 0
      if(this.Sensore != undefined)
      {
        for(let i = 0; i < this.Sensore.Dati.length; i++)
        {
          if(Result > this.Sensore.Dati[i].Pitch)
            Result = this.Sensore.Dati[i].Pitch
        }
      }
      return Result
    },

    GetMinDelta(Element)
    {
      return Math.min(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    GetMaxDelta(Element)
    {
      return Math.max(Math.abs(Element.MaxAccX - Element.MinAccX), Math.abs(Element.MaxAccY - Element.MinAccY), Math.abs(Element.MaxAccZ - Element.MinAccZ))
    },

    GetMaxMin()
    {
      let MinY = 0
      let MaxY = 10
      switch (this.TipoGrafico)
      {
        case TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_A:
        {
          if (this.Sensore.Dati.length != 0)
          {
            let FirstElement = this.Sensore.Dati[0]
            MinY = this.GetMinDelta(FirstElement) // fatto così nel vecchio ew, ma penso inutile
            MaxY = this.GetMaxDelta(FirstElement)
            for (let i = 0; i < this.Sensore.Dati.Count; i++)
            {
              MaxY = Math.max(MaxY, this.GetMaxDelta(this.Sensore.Dati[i]))
              MinY = Math.min(MinY, this.GetMinDelta(this.Sensore.Dati[i]))
            }
          }
          break
        }
        case TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F:
        {
          if (this.Sensore.Dati.length != 0)
          {
            let FirstElement = this.Sensore.Dati[0]
            MinY = 0
            MaxY = FirstElement.Conteggio
            for (let i = 0; i < this.Sensore.Dati.length; i++)
            {
              MaxY = Math.max(MaxY, this.Sensore.Dati[i].Conteggio)
            }
          }
          break
        }
      }
      return {Min : MinY, Max : MaxY}
    },

    Adatta()
    {
      this.ObjGrafico.AxisY.Min       = this.Dati.AxisY.Min
      this.ObjGrafico.AxisY.Max       = this.Dati.AxisY.Max
      this.ObjGrafico.AxisY.NotchDim  = this.Dati.AxisY.Udm
      this.ObjGrafico.AxisY.FontSize  = 13
      this.ObjGrafico.AxisY.LabelType = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
    },

    InserisciDati()
    {
      this.ObjGrafico.ClearAllGroupPoint()
      
      if (!this.EventiSovrapposti)
      {
        let Grafico = this.ObjGrafico.AddGroupPoint(1, 'blue', this.SpessoreGrafico, true)
        let StartDate = (Date.parse(this.Dati.Generale.DataEffettiva) + this.Dati.Generale.Millisecondi) - (Date.parse(this.MinData) + this.MinDataMs)
        for (let i = 0; i < this.Dati.Generale.Campioni.length; i++)
        {
          let YCoord = this.Dati.Generale.Campioni[i]
          let XCoord = StartDate + (i * this.Dati.Generale.PeriodoCampionamento)
          Grafico.AddPoint(XCoord, YCoord)
        }
      }
      else
      {
        for (let i = 0; i < this.Dati.Eventi.length; i++)
        {
          let SingleEvento = this.Dati.Eventi[i]
          let StartDate = (Date.parse(SingleEvento.DataEffettiva) + SingleEvento.Millisecondi) - (Date.parse(this.MinData) + this.MinDataMs)
          let IndexColore = i
          while (IndexColore >= COLORI_DEFAULT_GRAFICI.length)
          {
            IndexColore -= COLORI_DEFAULT_GRAFICI.length
          }
          let Grafico = this.ObjGrafico.AddGroupPoint(i, COLORI_DEFAULT_GRAFICI[IndexColore], this.SpessoreGrafico, true)
          for (let j = 0; j < SingleEvento.Campioni.length; j++)
          {
            let YCoord = SingleEvento.Campioni[j]
            let XCoord = StartDate + (j * SingleEvento.PeriodoCampionamento)

            Grafico.AddPoint(XCoord, YCoord)
          }
        }
      }
    },

    Disegna()
    {
      this.Adatta()
      this.InserisciDati()
      setTimeout(() => { this.ObjGrafico.Paint()}, 1)
    },
  },

  computed:
  {
    PropsGrafico :
    {
      get()
      {
        return this.Dati
      }
    },
  },

  watch:
  {
    Repaint:
    {
      handler(NewValue)
      {
        if (NewValue != 0)
        {
          this.ObjGrafico.AxisX.Max      = this.Dati.AxisX.Max
          this.ObjGrafico.AxisX.Min      = this.Dati.AxisX.Min
          this.ObjGrafico.AxisX.NotchDim = this.Dati.AxisX.Udm
          this.ObjGrafico.AxisY.Max      = this.Dati.AxisY.Max
          this.ObjGrafico.AxisY.Min      = this.Dati.AxisY.Min
          this.ObjGrafico.AxisY.NotchDim = this.Dati.AxisY.Udm
          this.ObjGrafico.AxisY.LabelType = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
          setTimeout(() => { this.ObjGrafico.Paint()}, 1)
        }
      }
    },

    RepaintDeep:
    {
      handler()
      {
        this.Disegna()
      }
    },
  },

  mounted()
  {
    // let Label = ''
    // if (this.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SINTETICI_F)
    // {
    //   Label = 'Frequenza eventi accelerometrici'
    //   this.ObjGrafico = new TZGraphHistogram(this.$refs.Canvas)
    //   this.ObjGrafico.PointWidth = 86400000
    //   this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblInteger
    // }
    // else
    // {
    //   Label = 'Ampiezza eventi accelerometrici [mg]'
    //   this.ObjGrafico = new TZGraphMarkup(this.$refs.Canvas)
    //   this.ObjGrafico.AxisY.LabelType     = TZGraphLabelType.lblCentesimi
    // }
    this.ObjGrafico = new TZGraphLine(this.$refs.Canvas)
    this.PropsGrafico.OggettoGrafico = this.ObjGrafico
    this.ObjGrafico.DrawMarkup = false
    this.ObjGrafico.__Margins.MinTop = 15
    this.ObjGrafico.__Margins.MinBottom = 10
    this.ObjGrafico.__Margins.MinLeft   += 30
    this.ObjGrafico.AxisX.DrawUpperLabel = false
    this.ObjGrafico.AxisX.UpperLabelText = this.GetTraduzioneLabel('VUEComponenteGraficoAccSupSoglie','TKN_GRAF_ACCEL_SUP_SOGL_ACC_ASSE',this.LinguaUtente) + ' ' + this.Tipo
    this.ObjGrafico.VerticalLabelAxisX = true
    this.ObjGrafico.AxisX.FontSize = 15
    this.ObjGrafico.AxisY.FontSize = 13
    this.ObjGrafico.AxisX.CenterLabel = this.GetTraduzioneLabel('VUEComponenteGraficoAccSupSoglie','TKN_GRAF_ACCEL_SUP_SOGL_TEMPO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKS_MILLISECONDO',this.LinguaUtente) + ']'
    this.ObjGrafico.AxisY.CenterLabel = this.GetTraduzioneLabel('VUEComponenteGraficoAccSupSoglie','TKN_GRAF_ACCEL_SUP_SOGL_ACC',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIGRAMMO',this.LinguaUtente) + ']'
    this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
    // this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblInteger 
    this.ObjGrafico.AxisX.NotchFontSize = 13
    
    this.ObjGrafico.__Margins.MinLeft   += 30

    this.ObjGrafico.AxisX.Min           = this.Dati.AxisX.Min
    
    this.ObjGrafico.AxisX.Max           = this.Dati.AxisX.Max //this.Dati.Generale.PeriodoCampionamento * this.Dati.Generale.Campioni.length
    this.ObjGrafico.AxisX.NotchDim      = this.Dati.AxisX.Udm
    this.ObjGrafico.AxisX.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisX.NotchDim))
    this.ObjGrafico.AxisY.Max           = this.Dati.AxisY.Max
    this.ObjGrafico.AxisY.Min           = this.Dati.AxisY.Min
    this.ObjGrafico.AxisY.NotchDim      = this.Dati.AxisY.Udm
    this.ObjGrafico.AxisX.NotchPenWidth = 1
    this.ObjGrafico.AxisY.NotchPenWidth = 1
    this.ObjGrafico.AxisX.NotchColor    = 'grey'
    this.ObjGrafico.AxisY.NotchColor    = 'grey'

    // this.PropsGraficoPerModifica.AxisY.Min = this.Sensore.MinAdattamentoAsseY
    // this.PropsGraficoPerModifica.AxisY.Max = this.Sensore.MaxAdattamentoAsseY
    // this.PropsGraficoPerModifica.AxisY.Udm = this.Sensore.UdmY

    this.InserisciDati()
    setTimeout(() => { this.ObjGrafico.Paint()}, 1)
  },

  beforeMount()
  {
    
  },
}
</script>